"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollTag = ScrollTag;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
function ScrollTag(_a) {
    var tags = _a.tags, value = _a.value, onClick = _a.onClick;
    var isActive = (0, react_1.useCallback)(function (tagValue) { return tagValue === value; }, [value]);
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, { flexWrap: "wrap", sx: {
            py: 2,
            overflowY: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '::-webkit-scrollbar': {
                height: 0,
                width: 0,
                display: 'none',
                MozAppearance: 'none',
                WebkitAppearance: 'none',
            },
        }, children: (0, jsx_runtime_1.jsx)(material_1.Stack, { spacing: 2, direction: "row", children: tags.map(function (tag, index) { return ((0, jsx_runtime_1.jsx)(material_1.Chip, { disabled: tag.disabled, label: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "subtitle1", color: "inherit", align: "justify", sx: {
                        whiteSpace: 'nowrap',
                    }, children: tag.label }), onClick: function () { return onClick(tag.value); }, color: isActive(tag.value) ? 'primary' : 'default', variant: isActive(tag.value) ? 'filled' : 'outlined', sx: {
                    height: 28,
                    borderRadius: 4,
                    bgcolor: isActive(tag.value)
                        ? 'primary.main'
                        : tag.disabled
                            ? 'transparent'
                            : 'background.default',
                    color: isActive(tag.value) ? 'background.default' : 'text.hint',
                    borderColor: isActive(tag.value) ? 'primary.main' : 'grey.100',
                    borderWidth: 1,
                    borderStyle: 'solid',
                } }, index)); }) }) }));
}
